import React from 'react';

const SplineSection = () => {
  return (
    <div style={{ 
      width: '100%', 
      height: '600px', 
      margin: '80px 0', 
      borderRadius: '40px', 
      overflow: 'hidden', 
      position: 'relative',
      background: 'var(--bg-soft)',
      boxShadow: 'var(--shadow-lg)'
    }}>
      {/* 
        ⚠️ INSTRUCCIONES PARA EL USUARIO:
        1. Ve a tu proyecto en Spline (https://app.spline.design/)
        2. Haz clic en "Export" -> "Viewer" -> "Update" o "Copy Link"
        3. Pega el nuevo link en el 'src' de abajo
      */}
      <iframe 
        src="https://my.spline.design/retrofuturismbganimation-OEUluWknMCKJgBdl7BVY0odg/" 
        frameBorder="0" 
        width="100%" 
        height="100%"
        title="Spline Medical Innovation"
        style={{ pointerEvents: 'auto' }}
      ></iframe>
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '10%',
        transform: 'translateY(-50%)',
        color: 'var(--primary-dark)',
        zIndex: 1,
        textAlign: 'left',
        maxWidth: '450px',
        pointerEvents: 'none',
        background: 'rgba(255, 255, 255, 0.8)',
        padding: '40px',
        borderRadius: '30px',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(255,255,255,0.3)'
      }}>
        <h2 style={{ fontSize: '2.5rem', fontWeight: '800', marginBottom: '15px' }}>Innovación que Sana</h2>
        <p style={{ fontSize: '1.2rem', color: 'var(--text-muted)', lineHeight: '1.6' }}>Utilizamos tecnología 3D y análisis metabólico avanzado para diseñar un plan de salud exclusivo para ti.</p>
      </div>
    </div>
  );
};

export default SplineSection;
